// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { GetTaxStatusForEntity_EntityFragment } from '../../../../content/sidebarContent/dispositiveProvisionsRecipientType/graphql/GetTaxStatusForEntity.generated';
import { gql } from '@apollo/client';
import { GetTaxStatusForEntity_EntityFragmentDoc } from '../../../../content/sidebarContent/dispositiveProvisionsRecipientType/graphql/GetTaxStatusForEntity.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EstateWaterfallModal_NodeConfigurationFragment = { __typename?: 'EntityGraphNodeConfiguration', nodeID: string, hidden?: boolean | null, height?: number | null, xPosition?: number | null, yPosition?: number | null };

export type EstateWaterfallModal_EstateWaterfallFragment = { __typename?: 'EstateWaterfall', id: string, displayName: string, createdAt: Time, kind?: Types.EstateWaterfallKind | null, firstGrantorDeathYear?: number | null, secondGrantorDeathYear?: number | null, filter?: { __typename?: 'EstateWaterfallVisualizationFilter', id: string } | null, parent?: { __typename?: 'EstateWaterfall', id: string, displayName: string } | null, firstGrantorDeath: { __typename?: 'ClientProfile', id: string }, nodeConfigurations: Array<(
    { __typename?: 'EntityGraphNodeConfiguration' }
    & EstateWaterfallModal_NodeConfigurationFragment
  )>, growthProfile?: { __typename?: 'GrowthProfile', displayName: string, id: string } | null, hypotheticalTransfers: { __typename?: 'EstateWaterfallHypotheticalTransferConnection', edges?: Array<{ __typename?: 'EstateWaterfallHypotheticalTransferEdge', node?: { __typename?: 'EstateWaterfallHypotheticalTransfer', id: string, sourceEntity?: { __typename?: 'Entity', id: string } | null } | null } | null> | null } };

export type EstateWaterfallModal_EntityFragment = (
  { __typename?: 'Entity', id: string, kind: Types.EntityKind, stage: Types.EntityStage, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, displayName: string, grantors?: Array<{ __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null }> | null } | { __typename?: 'CRTTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, displayName: string, grantors?: Array<{ __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null }> | null } | { __typename?: 'CustodialPersonalAccount', id: string, inEstateStatus: Types.EntityInEstateStatus, displayName: string, owner?: { __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null } | null } | { __typename?: 'DonorAdvisedFund', id: string, inEstateStatus: Types.EntityInEstateStatus, displayName: string, donors?: Array<{ __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null }> | null } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, displayName: string, grantor?: { __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null } | null } | { __typename?: 'ILITTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, displayName: string, grantors?: Array<{ __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null }> | null } | { __typename?: 'IndividualPersonalAccount', id: string, inEstateStatus: Types.EntityInEstateStatus, displayName: string, owner?: { __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null } | null } | { __typename?: 'InsurancePersonalAccount', id: string, inEstateStatus: Types.EntityInEstateStatus, displayName: string, owners?: Array<{ __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null }> | null } | { __typename?: 'IrrevocableTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, displayName: string, grantors?: Array<{ __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null }> | null } | { __typename?: 'JointPersonalAccount', id: string, inEstateStatus: Types.EntityInEstateStatus, displayName: string, owners?: Array<{ __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null }> | null } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, inEstateStatus: Types.EntityInEstateStatus, displayName: string, donors?: Array<{ __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null }> | null } | { __typename?: 'QPRTTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, displayName: string, grantors?: Array<{ __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null }> | null } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, inEstateStatus: Types.EntityInEstateStatus, displayName: string, owner?: { __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null } | null } | { __typename?: 'RetirementPersonalAccount', id: string, inEstateStatus: Types.EntityInEstateStatus, displayName: string, owner?: { __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null } | null } | { __typename?: 'RevocableTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, displayName: string, grantors?: Array<{ __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null }> | null } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, displayName: string, grantor?: { __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null } | null } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } }
  & GetTaxStatusForEntity_EntityFragment
);

export type CreateEstateWaterfallMutationVariables = Types.Exact<{
  input: Types.AugmentedCreateEstateWaterfallInput;
  opts?: Types.InputMaybe<Types.CreateEstateWaterfallOptsInput>;
}>;


export type CreateEstateWaterfallMutation = { __typename?: 'Mutation', createEstateWaterfall: { __typename?: 'EstateWaterfall', id: string, filter?: { __typename?: 'EstateWaterfallVisualizationFilter', id: string } | null } };

export type DuplicateEstateWaterfallMutationVariables = Types.Exact<{
  input: Types.DuplicateEstateWaterfallInput;
  opts?: Types.InputMaybe<Types.DuplicateEstateWaterfallOptsInput>;
}>;


export type DuplicateEstateWaterfallMutation = { __typename?: 'Mutation', duplicateEstateWaterfall: { __typename?: 'EstateWaterfall', id: string, filter?: { __typename?: 'EstateWaterfallVisualizationFilter', id: string } | null } };

export type UpdateEstateWaterfallMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateEstateWaterfallInput;
}>;


export type UpdateEstateWaterfallMutation = { __typename?: 'Mutation', updateEstateWaterfall: { __typename?: 'EstateWaterfall', id: string } };

export type EstateWaterfallQueryQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type EstateWaterfallQueryQuery = { __typename?: 'Query', estateWaterfalls: { __typename?: 'EstateWaterfallConnection', edges?: Array<{ __typename?: 'EstateWaterfallEdge', node?: (
        { __typename?: 'EstateWaterfall' }
        & EstateWaterfallModal_EstateWaterfallFragment
      ) | null } | null> | null } };

export type DeleteEstateWaterfallMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteEstateWaterfallMutation = { __typename?: 'Mutation', deleteEstateWaterfall: string };

export type DeleteEstateWaterfallFilterMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteEstateWaterfallFilterMutation = { __typename?: 'Mutation', deleteEstateWaterfallVisualizationFilter: string };

export type CreateEstateWaterfallVisualizationFilterMutationVariables = Types.Exact<{
  input: Types.AugmentedCreateEstateWaterfallVisualizationFilterInput;
}>;


export type CreateEstateWaterfallVisualizationFilterMutation = { __typename?: 'Mutation', createEstateWaterfallVisualizationFilter: { __typename?: 'EstateWaterfallVisualizationFilter', id: string } };

export type UpdateEstateWaterfallVisualizationFilterMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateEstateWaterfallVisualizationFilterInput;
}>;


export type UpdateEstateWaterfallVisualizationFilterMutation = { __typename?: 'Mutation', updateEstateWaterfallVisualizationFilter: { __typename?: 'EstateWaterfallVisualizationFilter', id: string } };

export type QueryEstateWaterfallModalQueryVariables = Types.Exact<{
  where: Types.HouseholdWhereInput;
}>;


export type QueryEstateWaterfallModalQuery = { __typename?: 'Query', households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: { __typename?: 'Household', id: string, entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
              { __typename?: 'Entity', id: string }
              & EstateWaterfallModal_EntityFragment
            ) | null } | null> | null }, estateWaterfalls?: Array<(
          { __typename?: 'EstateWaterfall' }
          & EstateWaterfallModal_EstateWaterfallFragment
        )> | null } | null } | null> | null } };

export type FiltersForEstateWaterfallQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.EstateWaterfallWhereInput>;
}>;


export type FiltersForEstateWaterfallQuery = { __typename?: 'Query', estateWaterfalls: { __typename?: 'EstateWaterfallConnection', edges?: Array<{ __typename?: 'EstateWaterfallEdge', node?: { __typename?: 'EstateWaterfall', id: string, filter?: { __typename?: 'EstateWaterfallVisualizationFilter', id: string, includedClients: { __typename?: 'ClientProfileConnection', edges?: Array<{ __typename?: 'ClientProfileEdge', node?: { __typename?: 'ClientProfile', id: string } | null } | null> | null }, includedEntities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string } | null } | null> | null } } | null } | null } | null> | null } };

export const Operations = {
  Query: {
    EstateWaterfallQuery: 'EstateWaterfallQuery' as const,
    QueryEstateWaterfallModal: 'QueryEstateWaterfallModal' as const,
    FiltersForEstateWaterfall: 'FiltersForEstateWaterfall' as const
  },
  Mutation: {
    CreateEstateWaterfall: 'CreateEstateWaterfall' as const,
    DuplicateEstateWaterfall: 'DuplicateEstateWaterfall' as const,
    UpdateEstateWaterfall: 'UpdateEstateWaterfall' as const,
    DeleteEstateWaterfall: 'DeleteEstateWaterfall' as const,
    DeleteEstateWaterfallFilter: 'DeleteEstateWaterfallFilter' as const,
    CreateEstateWaterfallVisualizationFilter: 'CreateEstateWaterfallVisualizationFilter' as const,
    UpdateEstateWaterfallVisualizationFilter: 'UpdateEstateWaterfallVisualizationFilter' as const
  },
  Fragment: {
    EstateWaterfallModal_NodeConfiguration: 'EstateWaterfallModal_NodeConfiguration' as const,
    EstateWaterfallModal_EstateWaterfall: 'EstateWaterfallModal_EstateWaterfall' as const,
    EstateWaterfallModal_Entity: 'EstateWaterfallModal_Entity' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EstateWaterfallModal_NodeConfigurationFragmentDoc = gql`
    fragment EstateWaterfallModal_NodeConfiguration on EntityGraphNodeConfiguration {
  nodeID
  hidden
  height
  xPosition
  yPosition
}
    `;
export const EstateWaterfallModal_EstateWaterfallFragmentDoc = gql`
    fragment EstateWaterfallModal_EstateWaterfall on EstateWaterfall {
  id
  displayName
  createdAt
  filter {
    id
  }
  kind
  parent {
    id
    displayName
  }
  firstGrantorDeath {
    id
  }
  nodeConfigurations {
    ...EstateWaterfallModal_NodeConfiguration
  }
  firstGrantorDeathYear
  secondGrantorDeathYear
  growthProfile {
    displayName
    id
  }
  hypotheticalTransfers {
    edges {
      node {
        id
        sourceEntity {
          id
        }
      }
    }
  }
}
    ${EstateWaterfallModal_NodeConfigurationFragmentDoc}`;
export const EstateWaterfallModal_EntityFragmentDoc = gql`
    fragment EstateWaterfallModal_Entity on Entity {
  id
  kind
  stage
  ...GetTaxStatusForEntity_Entity
  subtype {
    id
    displayName
    ... on CCorpBusinessEntity {
      id
    }
    ... on GPBusinessEntity {
      id
    }
    ... on LLCBusinessEntity {
      id
    }
    ... on LPBusinessEntity {
      id
    }
    ... on SoleProprietorshipBusinessEntity {
      id
    }
    ... on SCorpBusinessEntity {
      id
    }
    ... on CLTTrust {
      id
      inEstateStatus
      grantors {
        id
        individual {
          id
        }
      }
    }
    ... on CRTTrust {
      id
      inEstateStatus
      grantors {
        id
        individual {
          id
        }
      }
    }
    ... on CustodialPersonalAccount {
      id
      inEstateStatus
      owner {
        id
        individual {
          id
        }
      }
    }
    ... on DonorAdvisedFund {
      id
      inEstateStatus
      donors {
        id
        individual {
          id
        }
      }
    }
    ... on GRATTrust {
      id
      inEstateStatus
      grantor {
        id
        individual {
          id
        }
      }
    }
    ... on ILITTrust {
      id
      inEstateStatus
      grantors {
        id
        individual {
          id
        }
      }
    }
    ... on IndividualPersonalAccount {
      id
      inEstateStatus
      owner {
        id
        individual {
          id
        }
      }
    }
    ... on InsurancePersonalAccount {
      id
      inEstateStatus
      owners {
        id
        individual {
          id
        }
      }
    }
    ... on IrrevocableTrust {
      id
      inEstateStatus
      grantors {
        id
        individual {
          id
        }
      }
    }
    ... on JointPersonalAccount {
      id
      inEstateStatus
      owners {
        id
        individual {
          id
        }
      }
    }
    ... on PrivateFoundation {
      id
      inEstateStatus
      donors {
        id
        individual {
          id
        }
      }
    }
    ... on QPRTTrust {
      id
      inEstateStatus
      grantors {
        id
        individual {
          id
        }
      }
    }
    ... on QualifiedTuitionPersonalAccount {
      id
      inEstateStatus
      owner {
        id
        individual {
          id
        }
      }
    }
    ... on RetirementPersonalAccount {
      id
      inEstateStatus
      owner {
        id
        individual {
          id
        }
      }
    }
    ... on RevocableTrust {
      id
      inEstateStatus
      grantors {
        id
        individual {
          id
        }
      }
    }
    ... on SLATTrust {
      id
      inEstateStatus
      grantor {
        id
        individual {
          id
        }
      }
    }
  }
}
    ${GetTaxStatusForEntity_EntityFragmentDoc}`;
export const CreateEstateWaterfallDocument = gql`
    mutation CreateEstateWaterfall($input: AugmentedCreateEstateWaterfallInput!, $opts: CreateEstateWaterfallOptsInput) {
  createEstateWaterfall(input: $input, opts: $opts) {
    id
    filter {
      id
    }
  }
}
    `;
export type CreateEstateWaterfallMutationFn = Apollo.MutationFunction<CreateEstateWaterfallMutation, CreateEstateWaterfallMutationVariables>;

/**
 * __useCreateEstateWaterfallMutation__
 *
 * To run a mutation, you first call `useCreateEstateWaterfallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEstateWaterfallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEstateWaterfallMutation, { data, loading, error }] = useCreateEstateWaterfallMutation({
 *   variables: {
 *      input: // value for 'input'
 *      opts: // value for 'opts'
 *   },
 * });
 */
export function useCreateEstateWaterfallMutation(baseOptions?: Apollo.MutationHookOptions<CreateEstateWaterfallMutation, CreateEstateWaterfallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEstateWaterfallMutation, CreateEstateWaterfallMutationVariables>(CreateEstateWaterfallDocument, options);
      }
export type CreateEstateWaterfallMutationHookResult = ReturnType<typeof useCreateEstateWaterfallMutation>;
export type CreateEstateWaterfallMutationResult = Apollo.MutationResult<CreateEstateWaterfallMutation>;
export type CreateEstateWaterfallMutationOptions = Apollo.BaseMutationOptions<CreateEstateWaterfallMutation, CreateEstateWaterfallMutationVariables>;
export const DuplicateEstateWaterfallDocument = gql`
    mutation DuplicateEstateWaterfall($input: DuplicateEstateWaterfallInput!, $opts: DuplicateEstateWaterfallOptsInput) {
  duplicateEstateWaterfall(input: $input, opts: $opts) {
    id
    filter {
      id
    }
  }
}
    `;
export type DuplicateEstateWaterfallMutationFn = Apollo.MutationFunction<DuplicateEstateWaterfallMutation, DuplicateEstateWaterfallMutationVariables>;

/**
 * __useDuplicateEstateWaterfallMutation__
 *
 * To run a mutation, you first call `useDuplicateEstateWaterfallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateEstateWaterfallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateEstateWaterfallMutation, { data, loading, error }] = useDuplicateEstateWaterfallMutation({
 *   variables: {
 *      input: // value for 'input'
 *      opts: // value for 'opts'
 *   },
 * });
 */
export function useDuplicateEstateWaterfallMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateEstateWaterfallMutation, DuplicateEstateWaterfallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateEstateWaterfallMutation, DuplicateEstateWaterfallMutationVariables>(DuplicateEstateWaterfallDocument, options);
      }
export type DuplicateEstateWaterfallMutationHookResult = ReturnType<typeof useDuplicateEstateWaterfallMutation>;
export type DuplicateEstateWaterfallMutationResult = Apollo.MutationResult<DuplicateEstateWaterfallMutation>;
export type DuplicateEstateWaterfallMutationOptions = Apollo.BaseMutationOptions<DuplicateEstateWaterfallMutation, DuplicateEstateWaterfallMutationVariables>;
export const UpdateEstateWaterfallDocument = gql`
    mutation UpdateEstateWaterfall($input: AugmentedUpdateEstateWaterfallInput!) {
  updateEstateWaterfall(input: $input) {
    id
  }
}
    `;
export type UpdateEstateWaterfallMutationFn = Apollo.MutationFunction<UpdateEstateWaterfallMutation, UpdateEstateWaterfallMutationVariables>;

/**
 * __useUpdateEstateWaterfallMutation__
 *
 * To run a mutation, you first call `useUpdateEstateWaterfallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEstateWaterfallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEstateWaterfallMutation, { data, loading, error }] = useUpdateEstateWaterfallMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEstateWaterfallMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEstateWaterfallMutation, UpdateEstateWaterfallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEstateWaterfallMutation, UpdateEstateWaterfallMutationVariables>(UpdateEstateWaterfallDocument, options);
      }
export type UpdateEstateWaterfallMutationHookResult = ReturnType<typeof useUpdateEstateWaterfallMutation>;
export type UpdateEstateWaterfallMutationResult = Apollo.MutationResult<UpdateEstateWaterfallMutation>;
export type UpdateEstateWaterfallMutationOptions = Apollo.BaseMutationOptions<UpdateEstateWaterfallMutation, UpdateEstateWaterfallMutationVariables>;
export const EstateWaterfallQueryDocument = gql`
    query EstateWaterfallQuery($id: ID!) {
  estateWaterfalls(where: {id: $id}) {
    edges {
      node {
        ...EstateWaterfallModal_EstateWaterfall
      }
    }
  }
}
    ${EstateWaterfallModal_EstateWaterfallFragmentDoc}`;

/**
 * __useEstateWaterfallQueryQuery__
 *
 * To run a query within a React component, call `useEstateWaterfallQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstateWaterfallQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstateWaterfallQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEstateWaterfallQueryQuery(baseOptions: Apollo.QueryHookOptions<EstateWaterfallQueryQuery, EstateWaterfallQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EstateWaterfallQueryQuery, EstateWaterfallQueryQueryVariables>(EstateWaterfallQueryDocument, withFetchPolicyContext(options));
      }
export function useEstateWaterfallQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EstateWaterfallQueryQuery, EstateWaterfallQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EstateWaterfallQueryQuery, EstateWaterfallQueryQueryVariables>(EstateWaterfallQueryDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useEstateWaterfallQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EstateWaterfallQueryQuery, EstateWaterfallQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EstateWaterfallQueryQuery, EstateWaterfallQueryQueryVariables>(EstateWaterfallQueryDocument, withFetchPolicyContext(options));
        }
export type EstateWaterfallQueryQueryHookResult = ReturnType<typeof useEstateWaterfallQueryQuery>;
export type EstateWaterfallQueryLazyQueryHookResult = ReturnType<typeof useEstateWaterfallQueryLazyQuery>;
export type EstateWaterfallQuerySuspenseQueryHookResult = ReturnType<typeof useEstateWaterfallQuerySuspenseQuery>;
export type EstateWaterfallQueryQueryResult = Apollo.QueryResult<EstateWaterfallQueryQuery, EstateWaterfallQueryQueryVariables>;
export const DeleteEstateWaterfallDocument = gql`
    mutation DeleteEstateWaterfall($id: ID!) {
  deleteEstateWaterfall(id: $id)
}
    `;
export type DeleteEstateWaterfallMutationFn = Apollo.MutationFunction<DeleteEstateWaterfallMutation, DeleteEstateWaterfallMutationVariables>;

/**
 * __useDeleteEstateWaterfallMutation__
 *
 * To run a mutation, you first call `useDeleteEstateWaterfallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEstateWaterfallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEstateWaterfallMutation, { data, loading, error }] = useDeleteEstateWaterfallMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEstateWaterfallMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEstateWaterfallMutation, DeleteEstateWaterfallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEstateWaterfallMutation, DeleteEstateWaterfallMutationVariables>(DeleteEstateWaterfallDocument, options);
      }
export type DeleteEstateWaterfallMutationHookResult = ReturnType<typeof useDeleteEstateWaterfallMutation>;
export type DeleteEstateWaterfallMutationResult = Apollo.MutationResult<DeleteEstateWaterfallMutation>;
export type DeleteEstateWaterfallMutationOptions = Apollo.BaseMutationOptions<DeleteEstateWaterfallMutation, DeleteEstateWaterfallMutationVariables>;
export const DeleteEstateWaterfallFilterDocument = gql`
    mutation DeleteEstateWaterfallFilter($id: ID!) {
  deleteEstateWaterfallVisualizationFilter(id: $id)
}
    `;
export type DeleteEstateWaterfallFilterMutationFn = Apollo.MutationFunction<DeleteEstateWaterfallFilterMutation, DeleteEstateWaterfallFilterMutationVariables>;

/**
 * __useDeleteEstateWaterfallFilterMutation__
 *
 * To run a mutation, you first call `useDeleteEstateWaterfallFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEstateWaterfallFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEstateWaterfallFilterMutation, { data, loading, error }] = useDeleteEstateWaterfallFilterMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEstateWaterfallFilterMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEstateWaterfallFilterMutation, DeleteEstateWaterfallFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEstateWaterfallFilterMutation, DeleteEstateWaterfallFilterMutationVariables>(DeleteEstateWaterfallFilterDocument, options);
      }
export type DeleteEstateWaterfallFilterMutationHookResult = ReturnType<typeof useDeleteEstateWaterfallFilterMutation>;
export type DeleteEstateWaterfallFilterMutationResult = Apollo.MutationResult<DeleteEstateWaterfallFilterMutation>;
export type DeleteEstateWaterfallFilterMutationOptions = Apollo.BaseMutationOptions<DeleteEstateWaterfallFilterMutation, DeleteEstateWaterfallFilterMutationVariables>;
export const CreateEstateWaterfallVisualizationFilterDocument = gql`
    mutation CreateEstateWaterfallVisualizationFilter($input: AugmentedCreateEstateWaterfallVisualizationFilterInput!) {
  createEstateWaterfallVisualizationFilter(input: $input) {
    id
  }
}
    `;
export type CreateEstateWaterfallVisualizationFilterMutationFn = Apollo.MutationFunction<CreateEstateWaterfallVisualizationFilterMutation, CreateEstateWaterfallVisualizationFilterMutationVariables>;

/**
 * __useCreateEstateWaterfallVisualizationFilterMutation__
 *
 * To run a mutation, you first call `useCreateEstateWaterfallVisualizationFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEstateWaterfallVisualizationFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEstateWaterfallVisualizationFilterMutation, { data, loading, error }] = useCreateEstateWaterfallVisualizationFilterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEstateWaterfallVisualizationFilterMutation(baseOptions?: Apollo.MutationHookOptions<CreateEstateWaterfallVisualizationFilterMutation, CreateEstateWaterfallVisualizationFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEstateWaterfallVisualizationFilterMutation, CreateEstateWaterfallVisualizationFilterMutationVariables>(CreateEstateWaterfallVisualizationFilterDocument, options);
      }
export type CreateEstateWaterfallVisualizationFilterMutationHookResult = ReturnType<typeof useCreateEstateWaterfallVisualizationFilterMutation>;
export type CreateEstateWaterfallVisualizationFilterMutationResult = Apollo.MutationResult<CreateEstateWaterfallVisualizationFilterMutation>;
export type CreateEstateWaterfallVisualizationFilterMutationOptions = Apollo.BaseMutationOptions<CreateEstateWaterfallVisualizationFilterMutation, CreateEstateWaterfallVisualizationFilterMutationVariables>;
export const UpdateEstateWaterfallVisualizationFilterDocument = gql`
    mutation UpdateEstateWaterfallVisualizationFilter($input: AugmentedUpdateEstateWaterfallVisualizationFilterInput!) {
  updateEstateWaterfallVisualizationFilter(input: $input) {
    id
  }
}
    `;
export type UpdateEstateWaterfallVisualizationFilterMutationFn = Apollo.MutationFunction<UpdateEstateWaterfallVisualizationFilterMutation, UpdateEstateWaterfallVisualizationFilterMutationVariables>;

/**
 * __useUpdateEstateWaterfallVisualizationFilterMutation__
 *
 * To run a mutation, you first call `useUpdateEstateWaterfallVisualizationFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEstateWaterfallVisualizationFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEstateWaterfallVisualizationFilterMutation, { data, loading, error }] = useUpdateEstateWaterfallVisualizationFilterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEstateWaterfallVisualizationFilterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEstateWaterfallVisualizationFilterMutation, UpdateEstateWaterfallVisualizationFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEstateWaterfallVisualizationFilterMutation, UpdateEstateWaterfallVisualizationFilterMutationVariables>(UpdateEstateWaterfallVisualizationFilterDocument, options);
      }
export type UpdateEstateWaterfallVisualizationFilterMutationHookResult = ReturnType<typeof useUpdateEstateWaterfallVisualizationFilterMutation>;
export type UpdateEstateWaterfallVisualizationFilterMutationResult = Apollo.MutationResult<UpdateEstateWaterfallVisualizationFilterMutation>;
export type UpdateEstateWaterfallVisualizationFilterMutationOptions = Apollo.BaseMutationOptions<UpdateEstateWaterfallVisualizationFilterMutation, UpdateEstateWaterfallVisualizationFilterMutationVariables>;
export const QueryEstateWaterfallModalDocument = gql`
    query QueryEstateWaterfallModal($where: HouseholdWhereInput!) {
  households(where: $where) {
    edges {
      node {
        id
        entities {
          edges {
            node {
              id
              ...EstateWaterfallModal_Entity
            }
          }
        }
        estateWaterfalls {
          ...EstateWaterfallModal_EstateWaterfall
        }
      }
    }
  }
}
    ${EstateWaterfallModal_EntityFragmentDoc}
${EstateWaterfallModal_EstateWaterfallFragmentDoc}`;

/**
 * __useQueryEstateWaterfallModalQuery__
 *
 * To run a query within a React component, call `useQueryEstateWaterfallModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryEstateWaterfallModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryEstateWaterfallModalQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useQueryEstateWaterfallModalQuery(baseOptions: Apollo.QueryHookOptions<QueryEstateWaterfallModalQuery, QueryEstateWaterfallModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryEstateWaterfallModalQuery, QueryEstateWaterfallModalQueryVariables>(QueryEstateWaterfallModalDocument, withFetchPolicyContext(options));
      }
export function useQueryEstateWaterfallModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryEstateWaterfallModalQuery, QueryEstateWaterfallModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryEstateWaterfallModalQuery, QueryEstateWaterfallModalQueryVariables>(QueryEstateWaterfallModalDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useQueryEstateWaterfallModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryEstateWaterfallModalQuery, QueryEstateWaterfallModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryEstateWaterfallModalQuery, QueryEstateWaterfallModalQueryVariables>(QueryEstateWaterfallModalDocument, withFetchPolicyContext(options));
        }
export type QueryEstateWaterfallModalQueryHookResult = ReturnType<typeof useQueryEstateWaterfallModalQuery>;
export type QueryEstateWaterfallModalLazyQueryHookResult = ReturnType<typeof useQueryEstateWaterfallModalLazyQuery>;
export type QueryEstateWaterfallModalSuspenseQueryHookResult = ReturnType<typeof useQueryEstateWaterfallModalSuspenseQuery>;
export type QueryEstateWaterfallModalQueryResult = Apollo.QueryResult<QueryEstateWaterfallModalQuery, QueryEstateWaterfallModalQueryVariables>;
export const FiltersForEstateWaterfallDocument = gql`
    query FiltersForEstateWaterfall($where: EstateWaterfallWhereInput) {
  estateWaterfalls(where: $where, first: 1) {
    edges {
      node {
        id
        filter {
          id
          includedClients {
            edges {
              node {
                id
              }
            }
          }
          includedEntities {
            edges {
              node {
                id
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFiltersForEstateWaterfallQuery__
 *
 * To run a query within a React component, call `useFiltersForEstateWaterfallQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiltersForEstateWaterfallQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiltersForEstateWaterfallQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFiltersForEstateWaterfallQuery(baseOptions?: Apollo.QueryHookOptions<FiltersForEstateWaterfallQuery, FiltersForEstateWaterfallQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FiltersForEstateWaterfallQuery, FiltersForEstateWaterfallQueryVariables>(FiltersForEstateWaterfallDocument, withFetchPolicyContext(options));
      }
export function useFiltersForEstateWaterfallLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FiltersForEstateWaterfallQuery, FiltersForEstateWaterfallQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FiltersForEstateWaterfallQuery, FiltersForEstateWaterfallQueryVariables>(FiltersForEstateWaterfallDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useFiltersForEstateWaterfallSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FiltersForEstateWaterfallQuery, FiltersForEstateWaterfallQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FiltersForEstateWaterfallQuery, FiltersForEstateWaterfallQueryVariables>(FiltersForEstateWaterfallDocument, withFetchPolicyContext(options));
        }
export type FiltersForEstateWaterfallQueryHookResult = ReturnType<typeof useFiltersForEstateWaterfallQuery>;
export type FiltersForEstateWaterfallLazyQueryHookResult = ReturnType<typeof useFiltersForEstateWaterfallLazyQuery>;
export type FiltersForEstateWaterfallSuspenseQueryHookResult = ReturnType<typeof useFiltersForEstateWaterfallSuspenseQuery>;
export type FiltersForEstateWaterfallQueryResult = Apollo.QueryResult<FiltersForEstateWaterfallQuery, FiltersForEstateWaterfallQueryVariables>;